import { autocompletion, type CompletionSource } from "@codemirror/autocomplete"
import type { Extension } from "@codemirror/state"

const HELPERS = ["#if", "/if", "else", "#unless", "/unless", "#each", "/each"]

function source(paths: string[]): CompletionSource {
  return context => {
    const open = context.matchBefore(/\{\{[^{}]*/)
    if (!open) return null

    const word = open.text.match(/[#/\w.]*$/)![0]
    const dot = word.lastIndexOf(".")
    const prefix = word.slice(0, dot + 1)
    const segments = [...new Set(paths.filter(p => p.startsWith(prefix)).map(p => p.slice(prefix.length).split(".")[0]))]
    const options = segments.map(label => ({ label, type: paths.includes(prefix + label) ? "variable" : "namespace" }))

    return { from: open.to - (word.length - dot - 1), options: dot < 0 ? [...HELPERS.map(label => ({ label, type: "keyword" })), ...options] : options }
  }
}

// Autocomplete for handlebars templates: triggers inside "{{", offers block helpers and the known paths one segment at a time
export function handlebarsAutocomplete(paths: string[]): Extension {
  return autocompletion({ override: [source(paths)] })
}
